import React from "react"

export default function StartView({ onStart }) {
  return (
    <div>
      <p
        className="q-title start-copy"
      >
        Answer five short questions about how your organization handles brand and creative
        assets today. You'll get a readiness read and a next step suited to where you stand —
        no email is collected.
      </p>

      <div className="text-center">
        <button className="cta-btn" onClick={onStart}>
          Begin
        </button>
      </div>
    </div>
  )
}
